export default "__VITE_ASSET__DBKGwUyT__"